let parameters = {

    endpoint: {
        label: 'Endpoint',
        source: 'parameters.never',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: '',
        display: false,
        wait: false
    },
    tableName: {
        label: 'Tabe Name',
        source: 'parameters.never',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: '',
        display: false,
        wait: false
    },
    schema: {
        label: 'Schema',
        source: 'parameters.never',
        class: 'xs12 sm12 d-flex',
        type: 'none',
        value: '',
        display: false,
        wait: false
    }
};

export default parameters;
